import React, { useState } from "react";
import { connect } from "react-redux";
import { Chip, Tooltip, TextField, Typography, InputAdornment } from "@material-ui/core";
import { Clear } from "@material-ui/icons";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import KPTable from "../../../components/KPTable";
import MonographUpdateModal from "../MonographUpdateModal";
import MonographDeleteModal from "../MonographDeleteModal";
import HemisCodeConfirmModal from "../../../components/HemisCodeConfirmModal/HemisCodeConfirmModal";

import { updateMonograph, acceptMonograph } from "../../../reducer/monograph/action";
import { statisticUnaccepted } from "../../../reducer/profile/action";
import { notification } from "../../../reducer/home/action";

function MonographTable(props) {
  const [editting, setEditting] = useState(null);
  const [deleting, setDeleting] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [confirmingAccept, setConfirmingAccept] = useState(null);

  const handleUpdate = (e) => props.setUpdating(e);
  const handleEditYear = (e) => setEditting(e);

  const handleDelete = (event, e) => {
    setDeleting(e.id);
    setAnchorEl(event.currentTarget);
  };

  const handleChange = (value) => setEditting({ ...editting, dashboardYear: value });

  const handleSubmit = (e) => {
    e.preventDefault();
    props.updateMonograph(editting.id, editting);
    setEditting(null);
  };

  const handleClear = () => {
    props.updateMonograph(editting.id, { ...editting, dashboardYear: null });
    setEditting(null);
  };

  const acceptMonograph = async (e) => {
    let result = await props.acceptMonograph(e.id, !e.accepted);
    return result;
  };

  const handleAccept = (e) => {
    // If already accepted (canceling confirmation), no need for modal
    if (e.accepted) {
      acceptMonograph(e).then((success) => {
        if (success) {
          props.statisticUnaccepted({ departmentId: 0, profileId: props.profile?.id });
          if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
        }
      });
    } else {
      // If not accepted (confirming), show modal for HemisCode
      setConfirmingAccept(e);
    }
  };

  const handleConfirmAccept = (hemisCode) => {
    const updatedData = {
      ...confirmingAccept,
      hemisCode: hemisCode,
    };

    // First update the monograph with hemisCode
    props.updateMonograph(confirmingAccept.id, updatedData).then((updateResult) => {
      // Check for ERR_HEMIS_DUPLICATE error
      if (updateResult && updateResult.error === "ERR_HEMIS_DUPLICATE") {
        props.pushNoti({
          type: "warning",
          message: `Mã CTKH "${hemisCode}" đã tồn tại trong hệ thống. Vui lòng kiểm tra lại!`,
        });
        return;
      }

      if (updateResult && updateResult.success) {
        // Then call accept API
        acceptMonograph(confirmingAccept).then((acceptSuccess) => {
          if (acceptSuccess) {
            props.statisticUnaccepted({ departmentId: 0, profileId: props.profile?.id });
            if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
          }
        });
      }
    });

    setConfirmingAccept(null);
  };

  var list = [];
  if (props.type === "all") props.listMonograph.forEach((e) => list.push(e.monograph));
  else props.listMonographById.forEach((e) => list.push(e.monograph));

  const columns = [
    // {
    //   title: <b>ID</b>,
    //   key: 'id',
    //   width: '10%',
    //   sorter: (a, b) => a.id - b.id,
    // },
    {
      title: <b>Tên sách chuyên khảo</b>,
      key: "title",
      width: "21%",
      searchable: true,
      sorter: (a, b) => a.title.localeCompare(b.title),
    },
    {
      title: <b>Mã công trình</b>,
      key: "hemisCode",
      width: "9%",
      searchable: true,
      render: (value) =>
        value ? (
          <span style={{ wordBreak: "break-word" }}>{value}</span>
        ) : (
          <span style={{ color: "#aaa" }}>—</span>
        ),
    },
    {
      title: <b>Phân loại</b>,
      key: "type",
      width: "20%",
      type: "include",
      filters: [
        {
          text: "Chương sách",
          value: "chapter",
        },
        {
          text: "Chuyên khảo",
          value: "monograph",
        },
        {
          text: "Tham  khảo",
          value: "reference",
        },
        {
          text: "Giáo trình",
          value: "curriculum",
        },
      ],
      onFilter: (value, row) => row.filter((e) => value.includes(e.type)),
      render: (value) => {
        if (value === "chapter") return "Chương sách";
        if (value === "monograph") return "Chuyên khảo";
        if (value === "reference") return "Tham  khảo";
        if (value === "curriculum") return "Giáo trình";
        return "-";
      },
    },
    {
      title: <b>Tác giả</b>,
      key: "monographProfile",
      width: "20%",
      searchable: true,
      render: (value, row) => {
        if (!row?.monographProfile || row.monographProfile.length === 0) {
          return row?.listMember?.join(", ") || "-";
        }
        const authors = row.monographProfile
          .map((member) => {
            if (member.isInternal) {
              return props.profileList.find((p) => p.id === member.profileId)?.name || "";
            } else {
              return member.externalName || "";
            }
          })
          .filter((name) => name !== "")
          .join(", ");
        return authors || "-";
      },
    },
    {
      title: <b>Năm xuất bản</b>,
      key: "year",
      width: "12%",
      sorter: (a, b) => a.year - b.year,
    },
    props.role === "sudo-admin" && props.type === "all"
      ? {
          title: <b>Năm hiển thị</b>,
          key: "dashboardYear",
          width: "12%",
          searchable: true,
          render: (value, row) =>
            row?.id !== editting?.id ? (
              <Tooltip title="Click để chỉnh sửa năm">
                <div style={{ cursor: "pointer" }} onClick={() => handleEditYear(row)}>
                  {value > 0 ? value : "Chưa có năm hiển thị"}
                </div>
              </Tooltip>
            ) : (
              <form onSubmit={handleSubmit}>
                <TextField
                  fullWidth
                  size="small"
                  type="tel"
                  variant="outlined"
                  value={editting?.dashboardYear || ""}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" style={{ cursor: "pointer" }} onClick={handleClear}>
                        <Clear style={{ fontSize: 18 }} />
                      </InputAdornment>
                    ),
                  }}
                  onChange={(e) => handleChange(parseInt(e.target.value))}
                />
              </form>
            ),
        }
      : {
          key: "dashboardYear",
          width: "0%",
          render: () => null,
        },
    {
      title: <b>Tình trạng</b>,
      key: "accepted",
      width: "20%",
      render: (value) => (
        <Chip
          size="small"
          color={value ? "primary" : "secondary"}
          label={value ? "Đã được duyệt" : "Chưa được duyệt"}
        />
      ),
      type: "include",
      filters: [
        {
          text: "Đã được duyệt",
          value: true,
        },
        {
          text: "Chưa được duyệt",
          value: false,
        },
      ],
      onFilter: (value, row) => row.filter((e) => value.includes(e.accepted)),
    },
    // {
    //   title: <b>Mục đích</b>,
    //   key: "purposeId",
    //   width: "15%",
    //   type: "include",
    //   filters: props.purposes.filter(e => e.name !== 'bonusCalculated').map((e) => ({ value: e.id, text: e.description })),
    //   onFilter: (value, row) => row.filter((e) => value.includes(e.purposeId)),
    //   render: (value) => props.purposes.filter(e => e.name !== 'bonusCalculated').find((e) => e.id === value)?.description,
    // },
    {
      title: <b>Tác vụ</b>,
      key: "action",
      width: "20%",
      render: (value, row) =>
        row?.id !== editting?.id ? (
          <>
            <Typography
              className="table-action-buton"
              variant="caption"
              color="primary"
              onClick={() => handleUpdate(row)}
            >
              Chi tiết
            </Typography>
            {row.locked ? (
              <Typography className="table-action-buton" variant="caption" color="textPrimary">
                {`Đã khóa ${
                  (row.locked === "kpi" && "KPI") ||
                  (row.locked === "reward" && "thưởng") ||
                  (row.locked === "timeResearch" && "giờ nghiên cứu")
                }`}
              </Typography>
            ) : (
              <>
                {(props.type !== "all" || props.role === "sudo-admin") && !row.accepted && (
                  <Typography
                    className="table-action-buton"
                    variant="caption"
                    color="secondary"
                    onClick={(event) => handleDelete(event, row)}
                  >
                    Xoá
                  </Typography>
                )}
                {props.role === "sudo-admin" && props.filter !== "workingPaper" && row.purposeId !== 4 && (
                  <>
                    <Typography
                      className="table-action-buton"
                      variant="caption"
                      color="primary"
                      onClick={(event) => handleAccept(row)}
                    >
                      {row.accepted ? "Hủy xác nhận" : "Xác nhận"}
                    </Typography>
                  </>
                )}
              </>
            )}
          </>
        ) : (
          <>
            <Typography className="table-action-buton" variant="caption" color="primary" onClick={handleSubmit}>
              Lưu
            </Typography>
            <Typography
              className="table-action-buton"
              variant="caption"
              color="secondary"
              onClick={() => setEditting(null)}
            >
              Huỷ
            </Typography>
          </>
        ),
    },
  ];

  if (props.volumnType === "all") columns.splice(2, 1);

  return (
    <>
      <KPTable
        shadow="none"
        rowsPerPage={10}
        maxHeight="calc(100vh - 288px)"
        columns={columns}
        rows={list.sort((a) => (!a.accepted ? -1 : 1))}
        loading={props.isFetching}
      />
      <MonographUpdateModal adminTab={props.adminTab} updating={props.updating} setUpdating={props.setUpdating} />
      <MonographDeleteModal deleting={deleting} anchorEl={anchorEl} setAnchorEl={setAnchorEl} />
      <HemisCodeConfirmModal
        open={!!confirmingAccept}
        onClose={() => setConfirmingAccept(null)}
        onConfirm={handleConfirmAccept}
        currentHemisCode={confirmingAccept?.hemisCode || ""}
        title={confirmingAccept?.accepted ? "Hủy xác nhận sách chuyên khảo" : "Xác nhận sách chuyên khảo"}
        prefix="Sach"
        dashboardYear={confirmingAccept?.dashboardYear}
        departmentId={confirmingAccept?.departmentId}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  role: select(state, "userReducer", "role"),
  profile: select(state, "profileReducer", "detail"),
  profileList: select(state, "profileReducer", "list"),
  isFetching: select(state, "monographReducer", "isFetching"),
  listProject: select(state, "projectReducer", "list"),
  listMonograph: select(state, "monographReducer", "listFiltered"),
  listMonographById: select(state, "monographReducer", "listById"),
  purposes: select(state, "scientificResearchReducer", "purposes"),
});

const mapDispatchToProps = (dispatch) => ({
  acceptMonograph: (id, accept) => dispatch(acceptMonograph(id, accept)),
  statisticUnaccepted: (payload) => dispatch(statisticUnaccepted(payload)),
  updateMonograph: (id, payload) => dispatch(updateMonograph(id, payload)),
  pushNoti: (payload) => dispatch(notification(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(MonographTable));

